import type { ReactNode } from 'react';

/**
 * Los tres estados que toda pantalla que trae datos tiene que saber mostrar.
 *
 * Estan juntos a proposito: si cada pantalla los resuelve por su cuenta, la
 * mitad se olvida del error y la otra mitad muestra una tabla vacia que no se
 * distingue de "no hay nada". Un vacio y una falla NO se ven igual acá.
 */

export function Cargando({
  filas = 4,
  etiqueta = 'Cargando',
}: {
  filas?: number | undefined;
  etiqueta?: string | undefined;
}) {
  return (
    <div className="bloque__cuerpo" role="status" aria-live="polite" aria-label={etiqueta}>
      {Array.from({ length: filas }, (_, i) => (
        <div className="hueso" key={i} style={{ width: `${94 - i * 11}%` }} />
      ))}
    </div>
  );
}

export function ConError({
  titulo = 'No se pudo cargar',
  detalle,
  alReintentar,
}: {
  titulo?: string | undefined;
  detalle: string;
  alReintentar?: (() => void) | undefined;
}) {
  return (
    <div className="estado estado--error" role="alert">
      <p className="estado__titulo">{titulo}</p>
      <p className="estado__detalle">{detalle}</p>
      {alReintentar ? (
        <button type="button" className="boton" onClick={alReintentar}>
          Reintentar
        </button>
      ) : null}
    </div>
  );
}

/**
 * Un vacio es una invitacion a hacer algo, o una explicacion de por que no hay
 * nada. Nunca "sin resultados" a secas.
 */
export function Vacio({
  titulo,
  detalle,
  accion,
}: {
  titulo: string;
  detalle?: string | undefined;
  accion?: ReactNode | undefined;
}) {
  return (
    <div className="estado">
      <p className="estado__titulo">{titulo}</p>
      {detalle ? <p className="estado__detalle">{detalle}</p> : null}
      {accion}
    </div>
  );
}
